import { render, staticRenderFns } from "./settingHeader.vue?vue&type=template&id=3431349e"
import script from "./settingHeader.vue?vue&type=script&lang=js"
export * from "./settingHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports